import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DashValidation,
  isEmailValid,
  isEmptyOrNil,
  isNameLengthValid,
  isUrlValid,
} from 'dash-common';
import { FormContext, FormErrorTypes } from 'dash-ui';
import { FormFields } from '../../BrokerDetailsPage.constants';

export const useValidateBrokerInfoForm = () => {
  const { t } = useTranslation(['common', 'pages', 'forms']);
  const { errorHandlers } = useContext(FormContext);

  const validate = useCallback(
    (field: FormFields, value: string) => {
      const setInvalidMessage = (
        message: string,
        options: Record<string, string> = {}
      ) => {
        errorHandlers[field]({
          type: FormErrorTypes.Invalid,
          message: t(message, options),
        });
      };

      switch (field) {
        case FormFields.FirstName: {
          if (isEmptyOrNil(value)) {
            setInvalidMessage('forms:messages.firstNameBlank');
            return false;
          }
          if (!isNameLengthValid(value)) {
            setInvalidMessage('forms:messages.maxCharacterLimit', {
              number: DashValidation.MaxNameLength.toString(),
            });
            return false;
          }
          break;
        }
        case FormFields.LastName: {
          if (isEmptyOrNil(value)) {
            setInvalidMessage('forms:messages.lastNameBlank');
            return false;
          }
          if (!isNameLengthValid(value)) {
            setInvalidMessage('forms:messages.maxCharacterLimit', {
              number: DashValidation.MaxNameLength.toString(),
            });
            return false;
          }
          break;
        }
        case FormFields.AgencyName: {
          if (value) {
            if (!value.trim()) {
              setInvalidMessage('forms:messages.nameInvalid');
              return false;
            }
            if (!isNameLengthValid(value)) {
              setInvalidMessage('forms:messages.maxCharacterLimit', {
                number: DashValidation.MaxNameLength.toString(),
              });
              return false;
            }
          }
          break;
        }
        case FormFields.AgencyWebsite: {
          if (value && !isUrlValid(value)) {
            setInvalidMessage('forms:messages.urlInvalid');
            return false;
          }
          break;
        }
      }
      errorHandlers[field](null);
      return true;
    },
    [errorHandlers, t]
  );

  return validate;
};
